<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*background: #61A1F9;*/
  /*padding: 30px;*/
  /*height: calc( 100vh - 55px);*/
  /*box-sizing: border-box;*/

}
</style>



// WEBPACK FOOTER //
// src/App.vue